import { INVESTOR_TYPE_OPTIONS } from 'components/global/_helpers/global.consts';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitCreateInvestor } from 'components/views/FounderInvestors/_helpers/founderInvestors.events';
import { $view } from 'signals/global.signals';

const FounderCreateInvestorModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-investor-create'}
    title="Add Investor"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitCreateInvestor}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <UniversalInput
      type="select"
      options={INVESTOR_TYPE_OPTIONS}
      name="investorType"
      label="Investor Type"
      className="mb-16"
    />
    <UniversalInput
      name="investorName"
      label="Investor Name"
      className="mb-16"
    />
    <UniversalInput
      name="email"
      label="Email"
      className="mb-16"
    />
    <UniversalInput
      name="potentialCommitmentMin"
      label="Min Investment (Estimated)"
      className="mb-16"
      type="money"
    />
    <UniversalInput
      name="potentialCommitmentMax"
      label="Max Investment (Estimated)"
      className="mb-16"
      type="money"
    />
  </SimpleModal>

);

export default FounderCreateInvestorModal;
